document.addEventListener("DOMContentLoaded", () => {
    const selectBtns = document.querySelectorAll('.sample-card .add-btn')
    const addToCart = (e) => {
        const variantId = +e.target.dataset.variantId
        fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ items: [{
                id: variantId,
                quantity: 1
            }] }),
          })
          .then((response) => {
            if (response.status === 422) {
                response.json().then(parsedError => {
                    const msg = parsedError.description
                    const prodName = msg.substring(
                      msg.lastIndexOf("more") + 5, 
                      msg.lastIndexOf("to") -1);
          
                    var headings = document.evaluate(`//h4[contains(., '${prodName}')]`, document, null, XPathResult.ANY_TYPE, null);
                    var thisHeading = headings.iterateNext();
                    const errorSpan = thisHeading.parentElement.querySelector('.error')
                    errorSpan.innerText = msg
                })
            } else {
                window.location.href = `${window.location.origin}/cart`;
            }
          })
          .catch((error) => {
            error.json().then(parsedError => {
                const msg = parsedError.description
                const prodName = msg.substring(
                  msg.lastIndexOf("more") + 5, 
                  msg.lastIndexOf("to") -1);
      
                var headings = document.evaluate(`//h4[contains(., '${prodName}')]`, document, null, XPathResult.ANY_TYPE, null);
                var thisHeading = headings.iterateNext();
                const errorSpan = thisHeading.parentElement.querySelector('.error')
                errorSpan.innerText = msg
            })
          });
    }
    selectBtns.forEach(btn => {
        btn.addEventListener("click", addToCart)
    })
    const checkIfAnyInCart = () => {
        let canSelect = true
        const variants = []
        selectBtns.forEach(btn => {
            variants.push(+btn.dataset.variantId)
        })
        fetch("/cart.js", {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            }
          })
          .then(response => {
            response.json().then(parsedResponse => {
                const currentCartItems = parsedResponse.items
                currentCartItems.forEach(cartItem => {
                    if (variants.includes(cartItem.variant_id)) {
                        canSelect = false
                        const pickedVariant = document.querySelector(`.sample-card .add-btn[data-variant-id="${cartItem.variant_id}"`)
                        pickedVariant.classList.add('pickedVariant')
                        pickedVariant.innerText = "Remove"
                        pickedVariant.removeEventListener("click", addToCart)
                        pickedVariant.addEventListener("click", removeFromCart)
                        const otherVariants = document.querySelectorAll(`.sample-card .add-btn:not(.pickedVariant)`)
                        otherVariants.forEach(variant => {
                            variant.classList.add('locked')
                            variant.removeEventListener("click", addToCart)
                        })
                        return
                    }
                })
            })
          })
          .catch(error => {
            console.log(error)
          })
          
    }

    const removeFromCart = (e) => {
        const variantId = +e.target.dataset.variantId
        fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ 
                updates: {
                    [variantId]: 0,
                }
            }),
          })
          .then((response) => {
            if (response.status === 422) {
                response.json().then(parsedError => {
                    const msg = parsedError.description
                    const prodName = msg.substring(
                      msg.lastIndexOf("more") + 5, 
                      msg.lastIndexOf("to") -1);
          
                    var headings = document.evaluate(`//h4[contains(., '${prodName}')]`, document, null, XPathResult.ANY_TYPE, null);
                    var thisHeading = headings.iterateNext();
                    const errorSpan = thisHeading.parentElement.querySelector('.error')
                    errorSpan.innerText = msg
                })
            } else {
                window.location.href = `${window.location.origin}/cart`;
            }
          })
          .catch((error) => {
            error.json().then(parsedError => {
                const msg = parsedError.description
                const prodName = msg.substring(
                  msg.lastIndexOf("more") + 5, 
                  msg.lastIndexOf("to") -1);
      
                var headings = document.evaluate(`//h4[contains(., '${prodName}')]`, document, null, XPathResult.ANY_TYPE, null);
                var thisHeading = headings.iterateNext();
                const errorSpan = thisHeading.parentElement.querySelector('.error')
                errorSpan.innerText = msg
            })
          });
    }

    checkIfAnyInCart()
})